export default __webpack_public_path__ + "static/media/aave.4aac6349.webp";